import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { DRAWER_KEY, SERVICE_ORDER_DRAWER_BY_TYPE, SERVICE_ORDER_STATUS } from 'app-constants'
import { AICard } from 'components'
import { formatDate } from 'utils'
import { STATICS } from 'statics'
import { setDrawer } from 'slices/drawer'
import { OS_CTA, OS_CTA_LABEL, OS_CTA_TITLE, OS_STATUS, OS_TAG } from './constants'
import './style.scss'

export function HasOS({ data }) {
  const { detailedMessage, serviceOrder } = data
  const {
    can_reschedule: canReschedule,
    display_tracking_button: displayTrackingButton,
    expected_installation_date: expectedInstallationDate,
    expected_installation_turn: expectedInstallationTurn,
    tracking_url: trackingUrl,
    service_order_type: type,
    status,
  } = serviceOrder
  const [tag, setTag] = useState(OS_STATUS.SCHEDULED)
  const [cta, setCta] = useState(null)
  const [ctaUrl, setCtaUrl] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    function resolveCta() {
      const allowTrackVisit = displayTrackingButton
      const allowReschedule = canReschedule && status === SERVICE_ORDER_STATUS.ST_OS_CRIADA

      if (allowTrackVisit) {
        setCta(OS_CTA.TRACK_VISIT)
        setTag(OS_STATUS.ACTIVE)
        setCtaUrl(trackingUrl)
      } else if (allowReschedule) {
        setCta(OS_CTA.RESCHEDULE)
      }
    }

    resolveCta()
  }, [canReschedule, displayTrackingButton, serviceOrder, trackingUrl, status])

  function handleCtaClick() {
    switch (cta) {
      case OS_CTA.RESCHEDULE:
        dispatch(setDrawer(SERVICE_ORDER_DRAWER_BY_TYPE[type]))
        break
      case OS_CTA.TRACK_VISIT:
        break
      default:
        dispatch(setDrawer(DRAWER_KEY.NONE))
        break
    }
  }

  function getCtaLabel() {
    return OS_CTA_LABEL[cta] || OS_CTA_LABEL.DEFAULT
  }

  function getTitle() {
    return OS_CTA_TITLE[cta] || OS_CTA_TITLE.DEFAULT
  }

  function renderTag() {
    if (!tag) return null

    const { CLASS, LABEL } = OS_TAG[tag]

    return (
      <div className={`tag ${CLASS}`}>
        <div className='dot' />
        {LABEL}
      </div>
    )
  }

  function renderContent() {
    return (
      <div className='has-os-container'>
        {renderTag()}
        <div className='content'>
          <STATICS.CALENDAR_MONTH />
          {formatDate(expectedInstallationDate)}
        </div>
        <div className='content'>
          <STATICS.CLOCK_POINTERS />
          {expectedInstallationTurn}
        </div>
      </div>
    )
  }

  return (
    <AICard
      title={getTitle()}
      message={detailedMessage}
      ctaLabel={getCtaLabel()}
      onCtaClick={handleCtaClick}
      ctaUrl={ctaUrl}
    >
      {renderContent()}
    </AICard>
  )
}
